import {produce} from 'immer';
import {FilterState} from './filter.type';
import {FilterAction} from './filter.actions';
import {EQUALS, FacetValuesSortOrder, HibuEqualsFilter, HibuRangeFilter, RANGE} from '../facet.types';
import {facetUtils} from '../facet.utils';

const initialState: FilterState = {
    facets: [],
    filterPersisted: true,
    expandedFilterGroups: [],
    selectedFilters: {},
    sort: FacetValuesSortOrder.COUNT,
    showFilters: true,
    filtersPending: false,
};

export function filterReducer(state: FilterState = initialState, action: FilterAction): FilterState {
    return produce(state, (draft: FilterState) => {
        switch (action.type) {
            case 'FILTERS/SET_FACETS': {
                draft.facets = action.facets;
                break;
            }
            case 'FILTERS/CHANGE_PERSISTENCE': {
                draft.filterPersisted = action.filterPersisted;
                break;
            }
            case 'FILTERS/SELECT_FILTER': {
                const {filter, group} = action;

                if (!draft.selectedFilters[group]) {
                    draft.selectedFilters[group] = [];
                }
                if (!draft.selectedFilters[group].includes(filter)) {
                    draft.selectedFilters[group].push(filter);
                }
                break;
            }
            case 'FILTERS/UNSELECT_FILTER': {
                const {filter, group} = action;
                if (draft.selectedFilters[group]) {
                    draft.selectedFilters[group] = draft.selectedFilters[group].filter(
                        (f) => {
                            if (f.type === EQUALS) {
                                return !facetUtils.isSameEqualsFilter(f as HibuEqualsFilter, filter as HibuEqualsFilter);
                            } else if (f.type === RANGE) {
                                return !facetUtils.isSameRangeFilter(f as HibuRangeFilter, filter as HibuRangeFilter);
                            }
                        }
                    );
                    if (draft.selectedFilters[group].length < 1) { //if empty, then delete whole group
                        delete draft.selectedFilters[group];
                    }
                }
                break;
            }
            case 'FILTERS/UPDATE_ALL': {
                draft.selectedFilters = action.filters;
                break;
            }
            case 'FILTERS/CLEAR_ALL_SELECTED': {
                draft.expandedFilterGroups = [];
                draft.selectedFilters = {};
                draft.sort = FacetValuesSortOrder.COUNT;
                break;
            }
            case 'FILTERS/EXPAND_GROUP': {
                draft.expandedFilterGroups = [...state.expandedFilterGroups, action.group];
                break;
            }
            case 'FILTERS/COLLAPSE_GROUP': {
                draft.expandedFilterGroups = state.expandedFilterGroups
                    .filter((group) => group !== action.group);
                break;
            }
            case 'FILTERS/CHANGE_SORT': {
                draft.sort = action.sort;
                break;
            }
            case 'FILTERS/CHANGE_VISIBILITY': {
                draft.showFilters = action.showFilters;
                break;
            }
            case 'FILTERS/CHANGE_PENDING_STATE': {
                draft.filtersPending = action.filtersPending;
                break;
            }
        }
    });
}
